(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/core/assets/javascripts/numbergames-collection.js') >= 0) return;  svs.modules.push('/components/numbergames/core/assets/javascripts/numbergames-collection.js'); 
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
svs.numbergames.core.NumbergamesCollection = Backbone.Collection.extend({
  create(model, options) {
    options = options ? _.clone(options) : {};
    const {
      wait,
      save,
      success
    } = options;
    model = this._prepareModel(model, options);
    if (!model) return false;
    if (!wait) this.add(model, options);
    const collection = this;
    options.success = function (m, resp, callbackOpts) {
      if (wait) collection.add(m, callbackOpts);
      if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
    };
    save ? model.save(null, options) : model.fetch(options);
    return model;
  },
  add(models, options) {
    if (options.parseCollection) {
      models = this.parse(models, options);
    }
    return this.set(models, _.extend({
      merge: false
    }, options, {
      add: true,
      remove: false
    }));
  },
  toArray() {
    return this.map(model => {
      var _model$toObject, _model$toObject2;
      return (_model$toObject = (_model$toObject2 = model.toObject) === null || _model$toObject2 === void 0 ? void 0 : _model$toObject2.call(model)) !== null && _model$toObject !== void 0 ? _model$toObject : _objectSpread({}, model.attributes);
    });
  }
});
 })(window);